import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { useI18n } from '@/i18n';
import { Link } from '@/i18n/navigation';

const Footer: React.FC = () => {
  const { t } = useI18n();

  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold font-brand">Tutor Founder</span>
            </div>
            <p className="text-gray-200 mb-4">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/share/1BDuWagAuz/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.instagram.com/tutorfounder?igsh=MWk3MW42em52czQwbg==" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/tutors" className="text-gray-200 hover:text-accent transition-colors">
                  {t('footer.findTutors')}
                </Link>
              </li>
              <li>
                <Link to="/tuition-fee" className="text-gray-200 hover:text-accent transition-colors">
                  {t('nav.tuitionFeeReference')}
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-gray-200 hover:text-accent transition-colors">
                  {t('nav.howItWorks')}
                </Link>
              </li>
              <li>
                <Link to="/help-center" className="text-gray-200 hover:text-accent transition-colors">
                  {t('nav.helpCenter')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.company')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about-us" className="text-gray-200 hover:text-accent transition-colors">
                  {t('nav.aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/terms-customers" className="text-gray-200 hover:text-accent transition-colors">
                  {t('footer.termsCustomers')}
                </Link>
              </li>
              <li>
                <Link to="/terms-tutors" className="text-gray-200 hover:text-accent transition-colors">
                  {t('footer.termsTutors')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-200 hover:text-accent transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 mt-1 flex-shrink-0" />
                <span className="text-gray-200">{t('footer.location')}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 flex-shrink-0" />
                <span className="text-gray-200">+60 11-12049396</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span className="text-gray-200">tutorfounder@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-400 mt-8 pt-8 text-center text-gray-200">
          <p>
            <span
              onClick={() => window.__debugBridge?.onFooterTap?.()}
              className="cursor-default select-none"
              aria-hidden="true"
            >
              {t('footer.copyright')}
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
